import { Rule, HTMLarkdownOptions, PassDownOptions, FilterPredicate } from 'htmlarkdown';

const TABLE_ROLE = 'table';
const ROW_ROLE = 'row';
const COLUMN_HEADER_ROLE = 'columnheader';
const CELL_ROLE = 'cell';
const NEWLINE_CHARACTER = '\n';
const PIPE_SEPARATOR = '| ';
const DASH_SEPARATOR = '---';

export const tableFilter: FilterPredicate = (element: Element): boolean => {
    return element.getAttribute('role') === TABLE_ROLE;
};

export const tableRule: Rule = {
    filter: [tableFilter],
    replacement: (element: Element, _options: HTMLarkdownOptions, _parentOptions: PassDownOptions): string => {
        return convertTableToMarkdown(element);
    }
};

function convertTableToMarkdown(element: Element): string {
    let markdownTable = '';
    const rows = element.querySelectorAll(`[role="${ROW_ROLE}"]`);
    rows.forEach((row, rowIndex) => {
        markdownTable += convertRowToMarkdown(row);
        if (rowIndex === 0) {
            markdownTable += createHeaderSeparator(row);
        }
    });
    return markdownTable;
}

function convertRowToMarkdown(row: Element): string {
    let markdownRow = PIPE_SEPARATOR;
    const cells = Array.from(row.querySelectorAll(`[role="${COLUMN_HEADER_ROLE}"], [role="${CELL_ROLE}"]`));
    cells.forEach((cell) => {
        markdownRow += (cell.textContent?.trim() || '') + PIPE_SEPARATOR;
    });
    markdownRow += NEWLINE_CHARACTER;
    return markdownRow;
}

function createHeaderSeparator(row: Element): string {
    const cells = Array.from(row.querySelectorAll(`[role="${COLUMN_HEADER_ROLE}"], [role="${CELL_ROLE}"]`));
    return PIPE_SEPARATOR + cells.map(() => DASH_SEPARATOR).join(PIPE_SEPARATOR) + PIPE_SEPARATOR + NEWLINE_CHARACTER;
}
